/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Summary_CInputs */

const en_rd_summary_c = /** @type {(inputs: Rd_Summary_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workable, but an agent will guess a lot.`)
};

const id_rd_summary_c = /** @type {(inputs: Rd_Summary_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masih bisa jalan, tapi agent akan banyak menebak.`)
};

/**
* | output |
* | --- |
* | "Workable, but an agent will guess a lot." |
*
* @param {Rd_Summary_CInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_summary_c = /** @type {((inputs?: Rd_Summary_CInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Summary_CInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_summary_c(inputs)
	return en_rd_summary_c(inputs)
});